/**
 * web_vitals collector'i (opsiyonel).
 * LCP / INP / CLS degerleri PerformanceObserver ile toplanir ve sayfa
 * gizlenirken tek event olarak gonderilir.
 */
import { AUTO_EVENTS } from "../events";

class VitalsCollector {
    constructor(tracker) {
        this.tracker = tracker;
        this.lcp = 0;
        this.cls = 0;
        this.inp = 0;
        this.sent = false;
    }

    start() {
        if (!window.PerformanceObserver) return;
        const self = this;

        this.observe("largest-contentful-paint", function (entries) {
            const last = entries[entries.length - 1];
            if (last) self.lcp = Math.round(last.startTime || last.renderTime || 0);
        });

        this.observe("layout-shift", function (entries) {
            for (let i = 0; i < entries.length; i++) {
                // Kullanici etkilesiminden kaynaklanan kaymalar CLS'e dahil edilmez
                if (!entries[i].hadRecentInput) self.cls += entries[i].value || 0;
            }
        });

        this.observe("event", function (entries) {
            for (let i = 0; i < entries.length; i++) {
                const duration = entries[i].duration || 0;
                if (duration > self.inp) self.inp = Math.round(duration);
            }
        }, { durationThreshold: 40 });

        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === "hidden") self.send();
        });
        window.addEventListener("pagehide", function () {
            self.send();
        });
    }

    observe(type, callback, extraOptions) {
        try {
            const observer = new PerformanceObserver(function (list) {
                callback(list.getEntries());
            });
            const options = Object.assign({ type: type, buffered: true }, extraOptions || {});
            observer.observe(options);
        } catch (e) {
            /* tarayici bu metrigi desteklemiyor */
        }
    }

    send() {
        if (this.sent) return;
        if (!this.lcp && !this.cls && !this.inp) return;
        this.sent = true;

        const vitals = {
            lcp: this.lcp,
            inp: this.inp,
            cls: Math.round(this.cls * 1000) / 1000,
        };
        this.tracker.emit(AUTO_EVENTS.WEB_VITALS, vitals, { vitals: vitals });
        this.tracker.flush("web_vitals");
    }
}

export default VitalsCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/vitals.js
// module id = null
// module chunks = 